import { render, staticRenderFns } from "./MedicalLabelNiks.vue?vue&type=template&id=52c872f5&scoped=true&"
import script from "./MedicalLabelNiks.vue?vue&type=script&lang=js&"
export * from "./MedicalLabelNiks.vue?vue&type=script&lang=js&"
import style0 from "./MedicalLabelNiks.vue?vue&type=style&index=0&id=52c872f5&scoped=true&lang=scss&"
import style1 from "./MedicalLabelNiks.vue?vue&type=style&index=1&id=52c872f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c872f5",
  null
  
)

export default component.exports